<template>
  <div class="elder-image__custom-drop col middle">
    <span v-html="label"></span>
    <div v-if="$slots.default" class="mt-2"></div>
  </div>
</template>

<script>
export default {
  computed: {
    instance() {
      return this.$parent.$parent
    },
    label() {
      return this.$tc('dragImageOrDrop', this.instance.multiple ? 2 : 1)
    },
  },
}
</script>

<style lang="scss">
.elder-image__custom-drop {
  span {
    font-size: 0.9em;
  }
}
</style>
